module.exports = __webpack_public_path__ + "static/media/paske-1.0c4fe5ec.jpg";